import { Action } from 'redux';
import { AppState } from 'src';
import { AppDispatcher } from '@models/common.models';
import { contractService } from '@services/ContractService';
import { requestAction } from '@common/components/common.actions';
import { ContractEmailForm, EmailNotificationViewModel, ContractSendEmailsRequest } from '@models/Contract';

export enum ContractEmailActionType {
  SetContractEmailLoading = 'SetContractEmailLoading',
  SetContractEmailList = 'SetContractEmailList'
}

export interface SetContractEmailLoadingAction extends Action {
  readonly type: ContractEmailActionType.SetContractEmailLoading;
  readonly isLoading: boolean;
}

export function setContractEmailLoading(loading: boolean) {
  return {
    type: ContractEmailActionType.SetContractEmailLoading,
    isLoading: loading
  };
}

export interface SetContractEmailListAction extends Action {
  readonly type: ContractEmailActionType.SetContractEmailList;
  readonly contractEmailList: Array<EmailNotificationViewModel>;
}

export function setContractEmailList(contractEmailList: Array<EmailNotificationViewModel>): SetContractEmailListAction {
  return {
    type: ContractEmailActionType.SetContractEmailList,
    contractEmailList: contractEmailList
  };
}

export function getContractEmailList(contractId: number) {
  return async (dispatch: AppDispatcher, getState: () => AppState) => {
    return await dispatch(
      requestAction(() => contractService.getEmailList(contractId), setContractEmailList, {
        hasToast: false
      })
    );
  };
}

export function saveContractEmailSelections(contractId: number, formData: ContractEmailForm) {
  return async (dispatch: AppDispatcher, getState: () => AppState) => {
    let emailNotifications: Array<EmailNotificationViewModel> = [];
    const state = getState();
    const contractEmailsState = state.contract.contractEmail;
    if (contractEmailsState && contractEmailsState.contractEmailList) {
      formData.contractEmailList.map((value, index) => {
        if (value && value.email) {
          const emailNotificationVM = {
            email: contractEmailsState.contractEmailList[index].email,
            description: contractEmailsState.contractEmailList[index].description
          } as EmailNotificationViewModel;
          emailNotifications.push(emailNotificationVM);
        }
      });
      if (emailNotifications.length > 0) {
        const sendEmailsRequest: ContractSendEmailsRequest = {
          emailNotifications: emailNotifications,
          noDemandLetter: false,
          useDefaults: false
        };
        return await dispatch(sendConfirmationEmails(contractId, sendEmailsRequest));
      }
    }
    return Promise.reject('');
  };
}

export function sendConfirmationEmails(contractId: number, sendEmailsRequest: ContractSendEmailsRequest) {
  return async (dispatch: AppDispatcher, getState: () => AppState) => {
    return await dispatch(
      requestAction(
        () => contractService.sendConfirmation(contractId, sendEmailsRequest),
        () => {
          return { type: '' };
        },
        { hasToast: true, toastSuccessMessage: 'Contract Emails Sent Successfully.' }
      )
    );
  };
}

export function sendDefaultConfirmationEmails(contractId: number) {
  return async (dispatch: AppDispatcher, getState: () => AppState) => {
    const sendEmailsRequest: ContractSendEmailsRequest = {
      emailNotifications: [],
      noDemandLetter: false,
      useDefaults: true
    };
    return await dispatch(
      requestAction(
        () => contractService.sendConfirmation(contractId, sendEmailsRequest),
        () => {
          return { type: '' };
        },
        { hasToast: true, toastSuccessMessage: 'Contract Emails Sent Successfully.' }
      )
    );
  };
}



// WEBPACK FOOTER //
// ./src/contract/_components/contract-email/contract-email.actions.ts